













let startY: any = 0;
import { mapState } from 'vuex';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  computed: mapState(['isMobole']),

})
export default class Label extends Vue {
  @Prop() private value!: string;
  
  item = {
    icon: '',
    title: '',
    txt: '',
  };
  items = {
    Insulation: {
      icon: require('@/assets/images/mobile/insulation-icon.png'),
      title: '有效隔热',
      txt: '高效阻隔太阳热量，创造更舒适、怡人的车内环境，有效降低油耗。',
    },
     Ultraviolet: {
      icon: require('@/assets/images/mobile/Ultraviolet-icon.png'),
      title: '99% 隔绝紫外线',
      txt: '阻隔高达 99% 的紫外线，有效防晒，同时保护汽车内饰减缓褪色。',
    },
     Signal: {
      icon: require('@/assets/images/mobile/Signal-icon.png'),
      title: '无电子信号干扰',
      txt: '陶瓷材质不会对电子信号产生屏蔽，确保车内移动设备、GPS、ETC 等使用顺畅。',
    },
     Dazzle: {
      icon: require('@/assets/images/mobile/Dazzle-icon.png'),
      title: '防止眩光',
      txt: '超低内反光，减少眩光干扰，长效高光学清晰度，保障驾驶安全。',
    },
     Warranty: {
      icon: require('@/assets/images/mobile/Warranty-icon.png'),
      title: '超长质保',
      txt: '提供 8 年或终身质保，官方保障，售后无忧。',
    },
       Environment: {
      icon: require('@/assets/images/mobile/Environment-icon.png'),
      title: '环保材料',
      txt: '采用环保材质，呵护您家人的健康。',
    },

  };
  mounted() {}
  pageRouter(i) {
    this.$store.commit('setCurrentPage', i);
  }
}
